/* 支付页内可用券列表 */

<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>支付</span>
      <img :src="fanhuiIcon" :class="$style.fanhui" @click="back" />
    </header>
    <main>
      <div :class="$style.coupon">
        <div :class="$style.scrollWrap" ref="scroll">
          <ul :class="$style.couponList">
            <li
              v-for="(item, index) in payList"
              :key="index"
              :class="$style.couponItem"
              @click="handleSelect(item)"
            >
              <span
                :class="`${$style.selected} ${value.id === item.id ? $style.active : ''}  ${item.valid === 0 ? $style.disabled : ''
                }`"
              ></span>
              <div :class="$style.major">
                <div :class="$style.left">
                  <img
                    :src="
                      item.valid === 0
                        ? `${$cdnLink}/voucher/voucher_1.png?v=1`
                        : `${$cdnLink}/voucher/voucher.png`
                    "
                    alt
                    :class="$style.voucher"
                  />
                  <div>
                    <p :class="$style.name">{{ item.name }}</p>
                    <div :class="$style.condition" v-if="item.condition_money">
                      <img :src="`${$cdnLink}/voucher/notice.png`" alt />
                      <span
                        v-if="item.suit_game == 1 && item.freeze_status != 1"
                      >满{{ item.condition_money }}元可用</span>
                      <span v-else-if="item.freeze_status == 1" :class="$style.freeze">冷却中，{{handleUnfreezeTime(item)}}分钟后可再次使用</span>
                      <span v-else>当前游戏不可用</span>
                    </div>
                    <div :class="$style.condition" v-else-if="item.freeze_status == 1">
                      <img :src="`${$cdnLink}/voucher/notice.png`" alt />
                      <span>冻结中</span>
                    </div>
                  </div>
                </div>
                <div :class="$style.right">
                  <p v-if="item.type === 1" :class="$style.discount">
                    {{ item.off_money }}
                    <span>元</span>
                  </p>
                  <p v-else-if="item.type === 2" :class="$style.discount">
                    {{ item.percent * 10 }}
                    <span>折</span>
                  </p>
                  <p :class="$style.deadline">{{ diffDateline(item.invalid_time) }}后到期</p>
                </div>
              </div>
            </li>
          </ul>
          <div :class="$style.empty" v-if="!payList.length">
            <img :src="`${$cdnLink}/voucher/empty.png`" alt />
            <p>暂无可用代金券</p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import { mapActions, mapState } from 'vuex';
import { diffDateline } from '@/libs/utils';
import isFullScreen from '@/libs/business/fullScreen'
import moment from 'moment';

export default {
  name: '',
  props: {
    value: {
      default: ''
    },
    money: {},
    isH5: {
      type: Boolean
    },
  },
  data() {
    return {
      fullScreen: '',
      diffDateline,
      moment,
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.getCouponList();
  },
  beforeUnmount() {
    this.bs && this.bs.destroy();
  },
  computed: {
    ...mapState({
      payList: (state) => state.voucher.payList
    })
  },
  methods: {
    ...mapActions({
      getPayList: 'voucher/getPayList'
    }),
    handleUnfreezeTime(item) {
      if (item.unfreeze_time - item.server_time <= 0) {
        return 1
      } else {
        return moment(item.unfreeze_time * 1000).diff(moment(item.server_time * 1000), 'minutes') + 1
      }
    },
    scrollInit() {
      this.bs = new BScroll(this.$refs.scroll, {
        click: true
      });
    },
    async getCouponList() {
      await this.getPayList({ money: this.money });
      this.scrollInit();
    },
    back() {
      this.$emit('back');
    },
    handleSelect(item) {
      // 不可使用的代金券情况
      if (item.valid === 0) {
        return;
      }
      this.$emit('input', item);
      this.$emit('back');
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";
.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: .34rem;
      right: .34rem;
      width: .34rem;
      height: .24rem;
    }
  }
  > main {
    position: relative;
    .coupon {
      position: absolute;
      top: .2rem;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 100;
      font-size: 0;
      border-radius: .2rem;
      overflow: hidden;
      :global {
        .yw-guanbi {
          position: absolute;
          top: .14rem;
          right: .18rem;
          font-size: .5rem;
        }
        .yw-xiangzuo {
          position: absolute;
          top: .22rem;
          left: .18rem;
          font-size: .36rem;
        }
      }
      .title {
        text-align: center;
        line-height: .8rem;
        border-top-left-radius: .1rem;
        border-top-right-radius: .1rem;
        font-size: .36rem;
      }
      .scrollWrap {
        height: 100%;
        overflow: hidden;
        color: #000000;
        .couponList {
          padding: .2rem;
          .couponItem {
            background: #f7f7f7;
            border-radius: .14rem;
            margin-bottom: .14rem;
            padding: .2rem .12rem .2rem .22rem;
            display: flex;
            align-items: center;
            .selected {
              display: inline-block;
              width: .24rem;
              height: .24rem;
              border-radius: 50%;
              border: 1px solid #666666;
              box-sizing: border-box;
              margin-right: .22rem;
              &.active {
                position: relative;
                &:before {
                  position: absolute;
                  content: " ";
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  background: #49b81d;
                  width: .12rem;
                  height: .12rem;
                  border-radius: 50%;
                }
              }
              &.disabled {
                position: relative;
                &:before {
                  position: absolute;
                  content: " ";
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  background: #dfdfdf;
                  width: .12rem;
                  height: .12rem;
                  border-radius: 50%;
                }
              }
            }
            .major {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              .left {
                display: flex;
                align-items: center;
                text-align: left;
                .voucher {
                  width: .3rem;
                  height: .3rem;
                  margin-right: .12rem;
                }
                .name {
                  font-size: .26rem;
                  font-weight: 400;
                  margin-bottom: .1rem;
                }
                .condition {
                  display: flex;
                  align-items: center;
                  > img {
                    width: .14rem;
                    height: .14rem;
                    display: inline-block;
                    vertical-align: text-bottom;
                    margin-right: .04rem;
                  }
                  > span {
                    font-size: .16rem;
                    color: #666666;
                  }
                  .freeze {
                    color: #ff0000;
                  }
                }
              }
              .right {
                .discount {
                  font-size: .34rem;
                  color: #ff0000;
                  text-align: right;
                  margin-bottom: .12rem;
                  > span {
                    font-size: .26rem;
                  }
                }
                .deadline {
                  font-size: .16rem;
                  text-align: right;
                }
              }
            }
          }
        }
        .empty {
          box-sizing: border-box;
          padding-top: 15%;
          text-align: center;
          color: #9f9f9f;
          font-size: .22rem;
          > img {
            width: 1.18rem;
            height: .84rem;
            margin-bottom: .18rem;
          }
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      position: relative;
      .coupon {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 100;
        font-size: 0;
        border-radius: 10px;
        overflow: hidden;
        :global {
          .yw-guanbi {
            position: absolute;
            top: 7px;
            right: 9px;
            font-size: 25px;
          }
          .yw-xiangzuo {
            position: absolute;
            top: 11px;
            left: 9px;
            font-size: 18px;
          }
        }
        .title {
          text-align: center;
          line-height: 40px;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          font-size: 18px;
        }
        .scrollWrap {
          height: 100%;
          overflow: hidden;
          color: #000000;
          .couponList {
            padding: 10px;
            .couponItem {
              background: #f7f7f7;
              border-radius: 7px;
              margin-bottom: 7px;
              padding: 10px 6px 10px 11px;
              display: flex;
              align-items: center;
              .selected {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                border: 1px solid #666666;
                box-sizing: border-box;
                margin-right: 11px;
                &.active {
                  position: relative;
                  &:before {
                    position: absolute;
                    content: " ";
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    background: #49b81d;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                  }
                }
                &.disabled {
                  position: relative;
                  &:before {
                    position: absolute;
                    content: " ";
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    background: #dfdfdf;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                  }
                }
              }
              .major {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                .left {
                  display: flex;
                  align-items: center;
                  text-align: left;
                  .voucher {
                    width: 15px;
                    height: 15px;
                    margin-right: 6px;
                  }
                  .name {
                    font-size: 13px;
                    font-weight: 400;
                    margin-bottom: 5px;
                  }
                  .condition {
                    display: flex;
                    align-items: center;
                    > img {
                      width: 7px;
                      height: 7px;
                      display: inline-block;
                      vertical-align: text-bottom;
                      margin-right: 2px;
                    }
                    > span {
                      font-size: 8px;
                      color: #666666;
                    }
                  }
                }
                .right {
                  .discount {
                    font-size: 17px;
                    color: #ff0000;
                    text-align: right;
                    margin-bottom: 6px;
                    > span {
                      font-size: 13px;
                    }
                  }
                  .deadline {
                    font-size: 8px;
                    text-align: right;
                  }
                }
              }
            }
          }
          .empty {
            box-sizing: border-box;
            padding-top: 15%;
            text-align: center;
            color: #9f9f9f;
            font-size: 11px;
            > img {
              width: 59px;
              height: 42px;
              margin-bottom: 9px;
            }
          }
        }
      }
    }
  }
}
</style>